<template>
  <div>
    <b-overlay :show="showoverlay">
      <b-card class="bg-wash box-shadow-none border-0">
        <h4 class="mb-2 pb-2 border-bottom pb-2 mt-3">Leave Policy Management</h4>
        <p style="font-size: 15px;">Track and Assign leave policies to selected employees.</p>

        <div class="card border-0 bg-wash no-shadow d-flex flex-column" id="leave-policy-assign">
          <div class="d-flex justify-content-end" style="transform: translate(-280px, 49px);">
            <b-button variant="primary" @click="assignOffDayModal">Assign Leave Policy</b-button>
          </div>
          <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                       :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
        </div>

      </b-card>
    </b-overlay>


    <b-modal id="bv-modal-assign-off-day" title="Assign Leave Policy" :size="'md'" hide-footer>
      <b-form @submit.stop.prevent="onSubmit">

        <div>
          <b-form-group label="Leave Policy" label-for="pattern-id" class="required-field">
            <b-form-select id="pattern-id" name="leave_policy_id" v-model="fdata.leave_policy_id" :options="leave_policies" v-validate="'required'" data-vv-as="Leave Policy"
                           :state="validateState('leave_policy_id')" aria-describedby="pattern-id-feedback"/>
            <b-form-invalid-feedback id="pattern-id-feedback" v-if="veeErrors.has('leave_policy_id')">{{ veeErrors.first('leave_policy_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </div>

        <div class="mt-3">
          <b-button type="submit" variant="primary" block>Assign Leave Policy</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="bv-modal-offday-history" title="Off Day History" size="lg" hide-footer>
      <!-- Employee header -->
      <div v-if="employeeHeader" class="d-flex align-items-center mb-3">
        <img :src="$api_url + employeeHeader.employee_pic" class="mr-3 border p-1" style="width:56px;height:56px;object-fit:cover; border-radius: 50%;"/>
        <div>
          <div class="h5 mb-1 mb-0">{{ employeeHeader.name }} <small v-if="employeeHeader.employee_code" class="text-muted">({{ employeeHeader.employee_code}})</small></div>
          <div class="text-muted">
            <span v-if="employeeHeader.department">{{ employeeHeader.department }}</span>
            <span v-if="employeeHeader.department && employeeHeader.jobposition"> • </span>
            <span v-if="employeeHeader.jobposition">{{ employeeHeader.jobposition }}</span>
          </div>
        </div>
      </div>

      <div class="table-responsive employee-table-wrapper">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
          <thead class="table-head">
          <tr>
            <th>SL</th>
            <th v-for="column in columns">{{ column.label }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(s, index) in off_day_history" :key="s.id" class="hover-bg table-row border-bottom mx-2">
            <td>{{ index + 1 }}</td>
            <td>{{ s.template.name }}</td>
            <td> <span v-for="d in s.template.pattern_labels" :key="d" size="md" class="mr-1 mb-1  px-2 py-1 bg-info rounded">{{ d }}</span></td>
            <td>{{ s.period_start }}</td>
            <td>{{ s.period_end }}</td>
          </tr>

          <tr>
            <td colspan="6" v-if="off_day_history.length == 0">No off-day records found.</td>
          </tr>
          </tbody>
        </table>

      </div>

    </b-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      employees: [],
      leave_policies: [],
      custom_list: [],
      selected:[],
      list_key:0,
      company_options: [],
      showoverlay: false,
      default_column:['name','employee_code','email','department','jobposition', 'branch'],
      appended_column: [
        { value: "roster_leave_policy", text: "Roster Leave Policy", type: "text" },
        { value: "off_day", text: "Off Day", type: "text" },
      ],
      off_day_history:[],
      columns: [
        { key: 'template.name', label: 'Template' },
        { key: 'template.pattern_labels', label: 'Pattern' },
        { key: 'period_start', label: 'Start Date' },
        { key: 'period_end', label: 'End Date' },
      ],

      fdata: {
        leave_policy_id: null,
      },
    };
  },
  computed: {
    employeeHeader() {
      const first = this.off_day_history && this.off_day_history[0];
      return first && first.employee ? first.employee : null;
    },
  },
  methods: {
    listReturn(data){
      if(data.selected.length > 0)
      {
        this.selected = data.selected;
      }
      else
      {
        this.selected = [];
        if(data.employee_id > 0)
        {
          if(data.action_id == 1) {
            this.showOffDayHistory(data.employee_id);
          }
          else {

          }
        }

      }
    },
    showOffDayHistory(employee_id){
      axios.get(this.$api_url + '/roster/employees/off-days/' + employee_id).then(res => {
            this.off_day_history = res.data;
            this.$bvModal.show('bv-modal-offday-history');
            this.list_key++;
          }).catch((e) => {
            this.serverError(e);
          });
    },
    getEmployees() {
      axios.get(this.$api_url + '/roster/employees/list',{
        params:{
          fields:'offday,roster,shift'
        }
      }).then(res => {
        let tmp_employees = res.data.employee_data;
        this.list_key++;
        if(tmp_employees.length > 0 )
        {
          tmp_employees.forEach(element => {
            if(element.employee_id > 0)
            {
              let dop = [];
              dop = dop.concat([{ label: 'Show Off Day History' , value: 1 }]);
              element.actions = dop;
            }
          });

          this.custom_list = tmp_employees;

        }

        this.company_options = res.data.options;
      }).catch(e=>{
        this.serverError(e);
      });
    },

    resetForm(){
      this.fdata = {
        leave_policy_id: null,
      };
    },

    assignOffDayModal(){
      this.resetForm();
      if(this.selected.length == 0){
        this.$bvToast.toast("Please select employee(s) first",{
          variant:'danger',
          solid: true,
          title: 'Failed',
        });
        return;
      }
      this.$bvModal.show('bv-modal-assign-off-day');
    },

    getLeavePolicies() {
      axios.get(this.$api_url + '/roster/leave/policy/list').then(res => {
        this.leave_policies = res.data;
      }).catch(e=>{
        this.serverError(e);
      });
    },

    onSubmit() {

      let formData = new FormData();
      formData.append('leave_policy_id', this.fdata.leave_policy_id);
      formData.append('employee_ids', JSON.stringify(this.selected));
      this.showoverlay = true;
      axios.post(this.$api_url + '/roster/leave-policy-assign', formData).then(res => {
        this.resetForm();
        this.list_key++;
        this.$bvModal.hide('bv-modal-assign-off-day');
        this.$bvToast.toast(res.data.message, { variant: 'success', solid: true , title: 'Success'});
        this.selected = [];
        this.getEmployees();
        this.showoverlay = false;
      }).catch(e => {
      this.showoverlay = false;
        this.serverError(e);
      });
    }

  },
  created() {
    this.getEmployees();
    this.getLeavePolicies();
  }
};
</script>

<style>
.stat-card{border:1px solid rgba(0,0,0,.06);border-radius:1rem}
.stat-icon{width:42px;height:42px;border-radius:12px;display:grid;place-items:center}
.bg-soft-primary{background:rgba(13,110,253,.12)!important}
.bg-soft-warning{background:rgba(255,193,7,.16)!important}
.bg-soft-success{background:rgba(25,135,84,.12)!important}
.bg-soft-purple{background:rgba(111,66,193,.14)!important;color:#6f42c1!important}
.text-purple{color:#6f42c1!important}
#leave-policy-assign .trz_people_btn{
  position: absolute !important;
  right: 190px !important;
  top: 52px !important;
}
</style>
